/*
 * @Author: Charles Zhang
 * @Date: 2021-03-09 22:55:48
 * @Last Modified by: Charles Zhang
 * @Last Modified time: 2021-03-13 20:06:11
 */

import React, {Component} from "react";
import cookie from "react-cookies";
import PubSub from "pubsub-js";

import {Button, Card, Layout, Loading, MessageBox, Slider, Switch} from "element-react";

import CheckResultCluster from "./CheckResultCluster";
import CheckResultStatistic from "./CheckResultStatistic";
import CheckResultCompareLeft from "./CheckResultCompareLeft";
import CheckResultCompareRight from "./CheckResultCompareRight";
import MiniCard from "./MiniCard";

import encrypt from "../../components/RSA/encrypt"

import {Col, Row} from "reactstrap";

import {getCheckManifest, getCheckDocResult} from "api/getCheckResult";
import {decompressCheckDoc, decompressResultSummary} from "../../utils/decompressCheckDoc";
import ssoRefresh from "../../api/ssoRefresh";
import postCheckToken from "../../api/postCheckToken";

const MANIFEST_POLL_INTERVAL = 2500;

export default class ResultBoard extends Component {
  state = {
    result: [],
    clusterList: [],
    isClusterResultLoading: true,
    clusterLoadingText: "正在下载查重报告",
    isDocResultLoading: false,
    currentDocResult: null,
    summaryVisible: true,
    detailVisible: false,
    nowChooseDocumentID: "",
    nowChooseDocumentTitle: "",
    Medium2HighStatistic: this.isNumber(cookie.load("Medium2HighStatistic"))?parseInt(cookie.load("Medium2HighStatistic")):60,
    Low2MediumStatistic: this.isNumber(cookie.load("Low2MediumStatistic"))?parseInt(cookie.load("Low2MediumStatistic")):10,
    secret_mode: !this.props.secret_change,
  };

  manifestCache = {};
  docCache = {};
  currentJobID = "";
  manifestPollTimer = null;

  switchSummaryToDetail = (doc_id, title) => {
    this.setState({
      summaryVisible: false,
      detailVisible: true,
      nowChooseDocumentID: doc_id,
      nowChooseDocumentTitle: title,
      currentDocResult: null,
    });
    this.loadDocResult(doc_id);
  };

  switchDetailToSummary = () => {
    this.setState({
      summaryVisible: true,
      detailVisible: false,
    });
  };

  isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/;
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
    return regPos.test(val) || regNeg.test(val);
  }

  copy(value, onError, onSuccess) {
    if (value === undefined) return;
    const input = document.createElement("input");
    input.style.opacity = 0;
    input.style.position = 'fixed';
    input.style.left = "-100%";
    input.style.top = "-100%";
    input.value = value;
    document.body.appendChild(input);
    input.select()
    const success = document.execCommand("copy");
    document.body.removeChild(input);
    if (!success) {
      onError && onError();
      return;
    }
    onSuccess && onSuccess();
  }

  changeChineseToX(str){
      let next = str.replace(/[\u4e00-\u9fa5|,]/,'X');
      while(str !== next){
          str = next;
          next = next.replace(/[\u4e00-\u9fa5|,]/,'X');
      }
    return str;
  }

  queryList = (json) => {
    for (let i in json) {
        let son = json[i];
        if (typeof(son) === 'object'){
            this.queryList(son);
        }
        else if(i === "title") {
            json[i] = this.changeChineseToX(son);
        }
    }
  }

  applySecretMode = (data) => {
    const res = JSON.parse(JSON.stringify(data));
    this.queryList(res);
    return res;
  };

  clearManifestPollTimer = () => {
    if (this.manifestPollTimer) {
      clearTimeout(this.manifestPollTimer);
      this.manifestPollTimer = null;
    }
  };

  handleApiLogout = (data) => {
    try {
      if (data.message === "logout") {
        ssoRefresh();
      }
    } catch (e) {
      console.log(e);
    }
  };

  buildClusterStatistics = (result) => {
    const clusterList = [];
    const healthyDocuments = [];
    let low = 0;
    let mid = 0;
    let high = 0;
    const chartData = new Array(12).fill(0);
    let count = 1;

    for (const i in result.cluster_list) {
      const singleList = result.cluster_list[i];
      const tmpArray = [];

      for (const j in singleList) {
        const doc = singleList[j];
        const repetitiveRate = (doc.repetitive_rate * 100).toFixed(0);

        if (repetitiveRate < this.state.Low2MediumStatistic) {
          healthyDocuments.push(doc);
        } else {
          tmpArray.push(doc);
        }

        if (Number(repetitiveRate) === 0) {
          chartData[0] += 1;
        }

        chartData[Math.floor(repetitiveRate / 10) + 1] += 1;

        if (repetitiveRate < this.state.Low2MediumStatistic) {
          low += 1;
        } else if (repetitiveRate < this.state.Medium2HighStatistic) {
          mid += 1;
        } else {
          high += 1;
        }
      }

      if (tmpArray.length === 0) {
        continue;
      }

      clusterList.push({
        cluster: "类别" + count,
        documents: tmpArray,
      });
      count += 1;
    }

    healthyDocuments.sort((a, b) => b.repetitive_rate - a.repetitive_rate);
    clusterList.push({
      cluster: "低重复",
      documents: healthyDocuments,
    });

    return {
      clusterList,
      statistics: { low, mid, high, chartData },
    };
  };

  applyManifestToState = (manifest, secretMode) => {
    const result = secretMode ? this.applySecretMode(manifest) : manifest;
    const { clusterList, statistics } = this.buildClusterStatistics(result);

    this.setState({
      clusterList,
      statistics,
      isClusterResultLoading: false,
      clusterLoadingText: "正在下载查重报告",
    });
  };

  loadDocResult = (doc_id) => {
    const jobID = this.currentJobID;
    if (!jobID || !doc_id) {
      return;
    }

    if (!this.docCache[jobID]) {
      this.docCache[jobID] = {};
    }

    if (doc_id in this.docCache[jobID]) {
      let docResult = this.docCache[jobID][doc_id];
      if (this.state.secret_mode) {
        docResult = this.applySecretMode(docResult);
      }
      this.setState({
        currentDocResult: docResult,
        isDocResultLoading: false,
      });
      return;
    }

    this.setState({ isDocResultLoading: true, currentDocResult: null });

    getCheckDocResult(cookie.load("ACCESS_TOKEN"), jobID, doc_id)
      .then((response) => {
        const data = response.data.data;
        this.handleApiLogout(data);

        const result = data.result;
        if (result.status === "migrating") {
          MessageBox.alert("查重结果仍在准备中，请稍后再试。", "提示");
          this.setState({ isDocResultLoading: false });
          return;
        }
        if (result.status === "error") {
          MessageBox.alert(result.message || "加载文档详情失败，请重试。", "错误");
          this.setState({ isDocResultLoading: false });
          return;
        }

        const rawData = result.result_summary[doc_id];
        const docResult = decompressCheckDoc(rawData);
        this.docCache[jobID][doc_id] = docResult;

        let displayResult = docResult;
        if (this.state.secret_mode) {
          displayResult = this.applySecretMode(docResult);
        }

        this.setState({
          currentDocResult: displayResult,
          isDocResultLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isDocResultLoading: false });
      });
  };

  fetchManifestWithPoll = (jobID, secretMode) => {
    getCheckManifest(cookie.load("ACCESS_TOKEN"), jobID)
      .then((response) => {
        const data = response.data.data;
        this.handleApiLogout(data);

        const result = data.result;

        if (result.status === "migrating") {
          this.setState({
            isClusterResultLoading: true,
            clusterLoadingText: `正在准备查重结果… ${result.progress || 0}%`,
          });
          this.manifestPollTimer = setTimeout(() => {
            this.fetchManifestWithPoll(jobID, secretMode);
          }, MANIFEST_POLL_INTERVAL);
          return;
        }

        if (result.status === "error") {
          MessageBox.alert(result.message || "查重结果准备失败，请重试。", "错误");
          this.setState({ isClusterResultLoading: false });
          return;
        }

        if (result.result_summary && !result.cluster_list) {
          this.applyLegacyFullResult(jobID, result, secretMode);
          return;
        }

        this.manifestCache[jobID] = result;
        this.applyManifestToState(result, secretMode);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isClusterResultLoading: false });
      });
  };

  applyLegacyFullResult = (jobID, result, secretMode) => {
    const result_summary = decompressResultSummary(result.result_summary);
    this.docCache[jobID] = result_summary;

    const displayResult = secretMode ? this.applySecretMode(result) : result;
    const { clusterList, statistics } = this.buildClusterStatistics(displayResult);

    this.manifestCache[jobID] = result;
    this.setState({
      clusterList,
      statistics,
      isClusterResultLoading: false,
      clusterLoadingText: "正在下载查重报告",
    });
  };

  handleFetchCheckResult = (_, stateObj) => {
    this.clearManifestPollTimer();

    const jobID = stateObj.id;
    this.currentJobID = jobID;
    const secretMode = this.state.secret_mode;

    this.setState({
      clusterList: [],
      summaryVisible: true,
      detailVisible: false,
      isClusterResultLoading: true,
      clusterLoadingText: "正在下载查重报告",
      currentDocResult: null,
      isDocResultLoading: false,
    });

    if (jobID in this.manifestCache) {
      console.log(`查重任务：${jobID} 命中缓存！`);
      this.applyManifestToState(this.manifestCache[jobID], secretMode);
      return;
    }

    this.fetchManifestWithPoll(jobID, secretMode);
  };

  componentDidMount() {
    this.setState({ secret_mode: !this.props.secret_change});
    PubSub.unsubscribe("fetchCheckResult");
    PubSub.subscribe("fetchCheckResult", this.handleFetchCheckResult);
  }

  componentWillUnmount() {
    this.clearManifestPollTimer();
    PubSub.unsubscribe("fetchCheckResult");
  }

  render() {
    const {
      clusterList,
      nowChooseDocumentID,
      nowChooseDocumentTitle,
      isClusterResultLoading,
      clusterLoadingText,
      isDocResultLoading,
      currentDocResult,
      summaryVisible,
      detailVisible,
      secret_mode,
    } = this.state;

    let { statistics } = this.state;

    const { data } = this.props;

    return (
      <>
        <Layout.Row className="text-center mb-3">
          <Layout.Col span="24">
            <Card className="box-card">
              <Layout.Row gutter="30">
                <Layout.Col lg={this.props.secret_change?"4":"7"} md="8">
                  <MiniCard title="任务ID" content={data.id} />
                </Layout.Col>
                <Layout.Col lg="3" md="8">
                  <MiniCard title="文件数量" content={data.total + "篇"} />
                </Layout.Col>
                <Layout.Col lg={this.props.secret_change?"4":"8"} md="8">
                  <MiniCard title="始末时间" content={data.craeteTime + " - " + data.endTime} />
                </Layout.Col>
                <Layout.Col lg="2" md="8">
                  <MiniCard title="总用时" content={data.totalTime} />
                </Layout.Col>
                <Layout.Col lg="3" md="8" style={{display: this.props.secret_change?"block":"none"}}>
                  <MiniCard title="隐私模式" content={(
                      <Switch
                        value={secret_mode}
                        onColor="#4f455c"
                        offColor="#d4dcda"
                        onChange={(value)=>{
                          if(!this.props.secret_change) return;
                            this.setState({ secret_mode: value });
                            PubSub.publish("fetchCheckResult", { id: data.id});
                        }}>
                    </Switch>
                  )} />
                </Layout.Col>
                <Layout.Col lg="4" md="8" style={{display: this.props.secret_change?"block":"none"}}>
                  <MiniCard title="查重报告链接" content={(
                      <Button plain={true}
                              type="info"
                              onClick={() => {
                                if(!this.props.secret_change) MessageBox.alert('暂时没有权限！', '复制失败');
                                postCheckToken(cookie.load("ACCESS_TOKEN")).then((response) =>{
                                  try{
                                    if(response.data.data.message === "logout") {
                                      ssoRefresh();
                                    }
                                  }
                                  catch(e){
                                    console.log(e);
                                  }
                                  const s_token = encrypt("job_id=" + data.id + "&access_token=" + cookie.load("ACCESS_TOKEN").substring(0,50) + "&secret_change=" + !secret_mode);

                                  const url = window.location.origin + "/check_report?s_token=" + s_token;
                                  try{
                                    this.copy(url,() =>{
                                      MessageBox.msgbox({
                                        title: '消息',
                                        showInput: true,
                                        inputValue: url,
                                        message: '生成的查重报告链接如下，可直接粘贴至浏览器访问：',
                                      })
                                    },() =>{
                                      MessageBox.alert('已生成报告链接在剪贴板中，可直接粘贴至浏览器访问。', '复制成功');
                                    });
                                  }
                                  catch (e){
                                    MessageBox.msgbox({
                                      title: '消息',
                                      showInput: true,
                                      inputValue: url,
                                      message: '生成的查重报告链接如下，可直接粘贴至浏览器访问：',
                                    })
                                  }
                                })

                              }}
                      >链接导出</Button>
                  )} />
                </Layout.Col>
                <Layout.Col lg="4" md="8" style={{display: this.props.secret_change?"block":"none"}}>
                  <MiniCard title="查重结果概要" content={(
                      <Button plain={true}
                              type="info"
                              onClick={() => {
                                let csv_content = "标题,重复率,分类结果\n";
                                for(let cl in clusterList){
                                  const cluster_docs = clusterList[cl].documents
                                  for(let doc in cluster_docs){
                                    csv_content += cluster_docs[doc].title + "," + cluster_docs[doc].repetitive_rate * 100 + "%," + clusterList[cl].cluster + "\n";
                                  }
                                }
                                function makeDownload(fileName, fileType, content) {
                                  var pom = document.createElement('a');
                                  pom.setAttribute('href', 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(content));
                                  pom.setAttribute('download', `${fileName}.${fileType}`);
                                  if (document.createEvent) {
                                    var event = document.createEvent('MouseEvents');
                                    event.initEvent('click', true, true);
                                    pom.dispatchEvent(event);
                                  } else {
                                    pom.click();
                                  }
                                }
                                makeDownload(data.name, "csv", csv_content);
                              }}
                      >CSV导出</Button>
                  )} />
                </Layout.Col>
              </Layout.Row>
            </Card>
          </Layout.Col>
        </Layout.Row>
        <Layout.Row gutter="20">
          <div style={{ display: summaryVisible ? "block" : "none" }}>
            <Layout.Col span="12">
              <CheckResultCluster
                clusterList={clusterList}
                isClusterResultLoading={isClusterResultLoading}
                clusterLoadingText={clusterLoadingText}
                switchSummaryToDetail={this.switchSummaryToDetail}
                Medium2HighStatistic={this.state.Medium2HighStatistic}
                Low2MediumStatistic={this.state.Low2MediumStatistic}
              />
            </Layout.Col>
            <Layout.Col span="12">
              <CheckResultStatistic statistics={statistics} />
              <Card>
                <Row>
                  <Col lg="3" style={{padding: "6px"}}>
                    <h7><strong>中到高</strong>抄袭程度边界(%)</h7>
                  </Col>
                  <Col lg="9">
                    <div className="block">
                      <Slider value={this.state.Medium2HighStatistic}
                              max={100}
                              min={30}
                              showInput={true}
                              showTooltip={false}
                              onChange={(e)=>{
                                this.setState({Medium2HighStatistic:e});
                                cookie.save("Medium2HighStatistic", e, { path: "/" });
                                PubSub.publish("fetchCheckResult", { id: data.id });
                              }}
                      />
                    </div>
                  </Col>
                  </Row>
                <Row>
                  <Col lg="3"  style={{padding: "6px"}}>
                    <h7><strong>低到中</strong>抄袭程度边界(%)</h7>
                  </Col>
                  <Col lg="9">
                    <div className="block">
                      <Slider value={this.state.Low2MediumStatistic}
                              max={30}
                              min={0}
                              showInput={true}
                              showTooltip={false}
                              onChange={(e)=>{
                                this.setState({Low2MediumStatistic: e});
                                cookie.save("Low2MediumStatistic", e, { path: "/" });
                                PubSub.publish("fetchCheckResult", { id: data.id });
                              }}
                      />
                    </div>
                  </Col>
                </Row>
              </Card>
            </Layout.Col>
          </div>
          <div style={{ display: detailVisible ? "block" : "none" }}>
            <Layout.Col span="12">
              <Loading text="正在加载文档详情" loading={isDocResultLoading}>
                <CheckResultCompareLeft
                    id={nowChooseDocumentID}
                    title={nowChooseDocumentTitle}
                    resultSummary={currentDocResult}
                    switchDetailToSummary={this.switchDetailToSummary}
                />
              </Loading>
            </Layout.Col>
            <Layout.Col span="12">
              <CheckResultCompareRight />
            </Layout.Col>
          </div>
        </Layout.Row>
      </>
    );
  }
}
